/**
 * OrderPaymentModelViewService
 * Service for OrderPayment ModelView endpoints
 * Route: api/orderpayments
 * Controller: OrderPaymentModelViewController.cs
 */
import { BaseService } from '../base/BaseService';
/**
 * OrderPaymentModelViewService
 * Handles order payment model view queries (enriched data)
 * Maps to /api/orderpayments/{view-endpoints}
 */
export class OrderPaymentModelViewService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? OrderPaymentModelViewService.DEFAULT_SERVICE_PATH,
            basePath: OrderPaymentModelViewService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== SINGLE VIEW ====================
    /**
     * Get order payment model view by ID
     * GET /api/orderpayments/view/{id}
     */
    async getView(id) {
        const response = await this.getViewRaw(id);
        if (!response.data) {
            throw new Error(`Order payment view with ID ${id} not found`);
        }
        return response.data;
    }
    /**
     * Get order payment model view by ID (raw)
     */
    getViewRaw(id) {
        const endpoint = this.getEndpoint('view', `view/${id}`);
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
    // ==================== ALL VIEWS ====================
    /**
     * Get all order payment model views
     * GET /api/orderpayments/view
     */
    async getAllViews() {
        const response = await this.getAllViewsRaw();
        return response.data ?? [];
    }
    /**
     * Get all order payment model views (raw)
     */
    getAllViewsRaw() {
        const endpoint = this.getEndpoint('view-all', 'view');
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
    // ==================== VIEWS BY ORDER ====================
    /**
     * Get order payment views by order ID
     * GET /api/orderpayments/order/{orderId}/view
     */
    async getViewsByOrder(orderId) {
        const response = await this.getViewsByOrderRaw(orderId);
        return response.data ?? [];
    }
    /**
     * Get order payment views by order ID (raw)
     */
    getViewsByOrderRaw(orderId) {
        const endpoint = this.getEndpoint('views-by-order', `order/${orderId}/view`);
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
    // ==================== VIEWS BY STATUS ====================
    /**
     * Get order payment views by status
     * GET /api/orderpayments/status/{statusId}/view
     */
    async getViewsByStatus(statusId) {
        const response = await this.getViewsByStatusRaw(statusId);
        return response.data ?? [];
    }
    /**
     * Get order payment views by status (raw)
     */
    getViewsByStatusRaw(statusId) {
        const endpoint = this.getEndpoint('views-by-status', `status/${statusId}/view`);
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
    // ==================== VIEWS BY TYPE ====================
    /**
     * Get order payment views by type
     * GET /api/orderpayments/type/{typeId}/view
     */
    async getViewsByType(typeId) {
        const response = await this.getViewsByTypeRaw(typeId);
        return response.data ?? [];
    }
    /**
     * Get order payment views by type (raw)
     */
    getViewsByTypeRaw(typeId) {
        const endpoint = this.getEndpoint('views-by-type', `type/${typeId}/view`);
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
}
OrderPaymentModelViewService.DEFAULT_SERVICE_PATH = 'orders';
OrderPaymentModelViewService.BASE_PATH = 'api/orderpayments';
//# sourceMappingURL=OrderPaymentModelViewService.js.map